var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStarOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.957,
    height: 14.327,
    viewBox: "0 0 14.957 14.327",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-260.887 -461.167)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3867",
    transform: "translate(260.887 461.167)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2985",
    d: "M12.053,13.913,7.465,11.6l-4.5,2.469.78-5.077L0,5.472l5.07-.827L7.263,0,9.616,4.566l5.1.65L11.1,8.866Z",
    transform: "translate(0.247 0) rotate(1.007)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3836",
    d: "M351.637,451.38l-2.327,3.168,7.38-2.417Z",
    transform: "translate(-341.84 -446.675)",
    fill: "#ffe680"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3838",
    d: "M293.773,492.31v3.935L289.18,498.6Z",
    transform: "translate(-286.266 -484.504)",
    fill: "#fd5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3840",
    d: "M349.81,492.31l4.516,6.173-.848-5Z",
    transform: "translate(-342.302 -484.504)",
    fill: "#fd5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3842",
    d: "M253.1,452.22l7.327,2.344-2.264-3.094Z",
    transform: "translate(-252.919 -446.758)",
    fill: "#ffe680"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3844",
    d: "M349.81,398.758V391.09l2.26,4.573Z",
    transform: "translate(-342.302 -390.952)",
    fill: "#fd5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3846",
    d: "M289.8,498.539l.853-5.041,3.694-1.188Z",
    transform: "translate(-286.839 -484.504)",
    fill: "#ffd42a"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarOff);
export default __webpack_public_path__ + "static/media/star-off.8b0ec157a9a247faa10a731ceab28328.svg";
export { ForwardRef as ReactComponent };